// コンソールモジュール ページ国際化
export default {
    'workplace.greeting.midnight': '深夜好',
    'workplace.greeting.earlyMorning': 'おはようございます',
    'workplace.greeting.noon': 'こんにちは',
    'workplace.greeting.afternoon': 'こんにちは',
    'workplace.greeting.evening': 'こんばんは',
    'workplace.date.sunday': '日曜日',
    'workplace.date.monday': '月曜日',
    'workplace.date.tuesday': '火曜日',
    'workplace.date.wednesday': '水曜日',
    'workplace.date.thursday': '木曜日',
    'workplace.date.friday': '金曜日',
    'workplace.date.saturday': '土曜日',
    'workplace.date.format': '{year}年{month}月{day}日',
    
    'workplace.stat.availableApps': '利用可能なアプリ',
    'workplace.stat.tokenConsumption': 'トークン消費量',
    
    'workplace.recentApps.title': 'よく使うアプリ',
    'workplace.recentApps.viewAll': 'すべて表示',
    'workplace.recentApps.empty.description': '最近アクセスしたアプリはありません、',
    'workplace.recentApps.empty.link': '探索する',
    'workplace.recentApps.noDescription': '説明なし',
    
    'workplace.quickNav.title': 'クイックナビゲーション',
    'workplace.quickNav.add': '追加',
    'workplace.quickNav.edit': 'クイックナビゲーションを編集',
    'workplace.quickNav.addNew': 'クイックナビゲーションを追加',
    'workplace.quickNav.modal.title': 'タイトル',
    'workplace.quickNav.modal.titlePlaceholder': 'タイトルを入力してください',
    'workplace.quickNav.modal.link': 'リンク',
    'workplace.quickNav.modal.linkRequired': 'リンクを選択または入力してください',
    'workplace.quickNav.modal.menuTab': 'メニューを選択',
    'workplace.quickNav.modal.customTab': 'カスタムリンク',
    'workplace.quickNav.modal.menuPlaceholder': 'メニューを選択してください',
    'workplace.quickNav.modal.customPlaceholder': 'カスタムリンクを入力してください（例：/dashboard/workplace）',
    'workplace.quickNav.deleteConfirm.title': '削除の確認',
    'workplace.quickNav.deleteConfirm.content': 'このクイックナビゲーションを削除してもよろしいですか？',
    'workplace.quickNav.deleteSuccess': '削除しました',
    'workplace.quickNav.editSuccess': '更新しました',
    'workplace.quickNav.addSuccess': '追加しました',
    
    'workplace.accessibleModules.title': 'アクセス可能なモジュール',
    
    'workplace.profile.company': '会社',
    'workplace.profile.department': '部門',
    'workplace.profile.email': 'メールアドレス',

      // 新增的 nav 相关键名
  'workplace.nav.edit': '編集',
  'workplace.nav.delete': '削除',
  'workplace.nav.add': '追加',
  };
